/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type OfferType = "buy" | "rent";
import type { FragmentReference } from "relay-runtime";
declare export opaque type useListingStructuredData_listing$ref: FragmentReference;
declare export opaque type useListingStructuredData_listing$fragmentType: useListingStructuredData_listing$ref;
export type useListingStructuredData_listing = {|
  +currency: ?string,
  +images: $ReadOnlyArray<{|
    +bucketName: string,
    +fileName: string,
  |}>,
  +grossRentMonthly: ?number,
  +livingSurface: ?number,
  +numberOfRooms: ?number,
  +postcode: ?string,
  +propertyMainType: ?string,
  +lat: ?number,
  +lng: ?number,
  +propertyType: ?string,
  +route: ?string,
  +salePrice: ?number,
  +streetNumber: ?string,
  +subLocality: ?string,
  +encodedId: string,
  +offerType: OfferType,
  +$refType: useListingStructuredData_listing$ref,
|};
export type useListingStructuredData_listing$data = useListingStructuredData_listing;
export type useListingStructuredData_listing$key = {
  +$data?: useListingStructuredData_listing$data,
  +$fragmentRefs: useListingStructuredData_listing$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useListingStructuredData_listing",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        }
      ],
      "concreteType": "AggregatesListingImage",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bucketName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fileName",
          "storageKey": null
        }
      ],
      "storageKey": "images(first:100)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "grossRentMonthly",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "livingSurface",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "numberOfRooms",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postcode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "propertyMainType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lat",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lng",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "propertyType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "route",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "salePrice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "streetNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subLocality",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "encodedId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "offerType",
      "storageKey": null
    }
  ],
  "type": "AggregatesListing",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '3dfacfea030274b14bbefa2d66a19892';

export default node;
